import React from 'react';
import { Box, Card, Stack, Typography, Chip, Divider } from '@mui/material';
import { AccessTime, DeleteOutline } from '@mui/icons-material';
import dayjs from 'dayjs';
import { ButtonUI } from '../../Interface';
import { EmployeeAbsenceApprovalStatus } from '../../../config/employeeAbsenceRequest';

const DetailRow = ({ label, children }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" py={1.5} spacing={2}>
    <Typography fontSize={14} color="text.secondary">
      {label}
    </Typography>
    <Box sx={{ textAlign: 'right' }}>{children}</Box>
  </Stack>
);

const EmployeeAbsenceRequestDetails = ({ request, onWithdraw, getStatusData, onBack }) => {
  if (!request) return null;

  const statusData = getStatusData(request.approvalStatus);

  const days = dayjs(request.endDate).diff(dayjs(request.startDate), 'day') + 1;

  return (
    <Box sx={{ p: 2 }}>
      <ButtonUI text="Vissza az igénylésekhez" onClick={onBack} className="bg-warning mb-4" size="sm" />
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{ p: { xs: 1, sm: 2.5 }, mb: 2, bgcolor: '#FFF8E9', border: '1px solid #FFE5AE', borderRadius: 2 }}
      >
        <AccessTime sx={{ color: '#A66A00', fontSize: 30 }} />

        <Box>
          <Chip
            label={statusData?.label}
            size="small"
            sx={{ bgcolor: statusData?.colorBgCode, color: statusData?.textColor, fontWeight: 600 }}
          />

          {request.approvalStatus === EmployeeAbsenceApprovalStatus.PENDING && (
            <Typography fontSize={14} color="#8A5700" mt={1}>
              Az igénylés elküldésre került, jóváhagyásra vár.
            </Typography>
          )}
        </Box>
      </Stack>

      <Card sx={{ p: 2.5, borderRadius: 2, mb: 2 }}>
        <DetailRow label="Időszak">
          <Typography fontSize={14}>
            {dayjs(request.startDate).format('YYYY. MM. DD.')} – {dayjs(request.endDate).format('YYYY. MM. DD.')}
          </Typography>
        </DetailRow>
        <Divider />

        <DetailRow label="Időtartam">
          <Typography fontSize={14}>{days} nap</Typography>
        </DetailRow>
        <Divider />

        <DetailRow label="Főkategória">
          <Typography fontSize={14}>Szabadság</Typography>
        </DetailRow>
        <Divider />

        <DetailRow label="Státusz">
          <Chip
            label={statusData?.label}
            size="small"
            sx={{ bgcolor: statusData?.colorBgCode, color: statusData?.textColor }}
          />
        </DetailRow>
        <Divider />

        <DetailRow label="Létrehozva">
          <Typography fontSize={14}>{dayjs(request.createdAt).format('YYYY. MM. DD. HH:mm')}</Typography>
        </DetailRow>
      </Card>

      {request.description && (
        <Card sx={{ p: 2.5, borderRadius: 2, mb: 2 }}>
          <Typography fontWeight={600} mb={1}>
            Megjegyzés
          </Typography>
          <Typography fontSize={14}>{request.description}</Typography>
        </Card>
      )}

      {request.approvalStatus === EmployeeAbsenceApprovalStatus.PENDING && (
        <Box textAlign="center">
          <ButtonUI className="bg-danger" onClick={() => onWithdraw(request.id)} text="Igénylés visszavonása" />
        </Box>
      )}
    </Box>
  );
};

export default EmployeeAbsenceRequestDetails;
